export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13776.3e637001.jpg";